import React from 'react'

import { Card, CardHeader } from '@material-ui/core'

import PageInfo from '../../../PageInfo/PageInfo'
import AppraisalInfo from '../AppraisalInfo/AppraisalInfo'
import StructureTabs from './StructureTabs/StructureTabs'

const AppraisalResultContent = ({
  appraisalData,
  appraisalInfo,
  inputChanged,
  openCommentModal,
  calculateButtonClicked,
  submitButtonClicked,
  cancelButtonClicked,
  showActionTo,
  actionToButtonClicked,
  showSumUp,
  sumUpButtonClicked,
  savedList,
  loadingStates,
  isAdmin
}) => {
  return (
    <Card>
      <CardHeader title={<PageInfo pageTranslateKey={'appraisal'} />} />
      <AppraisalInfo appraisalInfo={appraisalInfo} />
      <StructureTabs
        appraisalInfo={appraisalInfo}
        appraisalData={appraisalData}
        inputChanged={data => inputChanged(data)}
        openCommentModal={openCommentModal}
        calculateButtonClicked={calculateButtonClicked}
        submitButtonClicked={submitButtonClicked}
        cancelButtonClicked={cancelButtonClicked}
        showActionTo={showActionTo}
        actionToButtonClicked={actionToButtonClicked}
        showSumUp={showSumUp}
        sumUpButtonClicked={sumUpButtonClicked}
        savedList={savedList}
        loadingStates={loadingStates}
        isAdmin={isAdmin}
      />
    </Card>
  )
}

export default AppraisalResultContent
